export default __webpack_public_path__ + "static/media/dodecahedron.a2c60437.png";